import { status } from 'skin/event/status';
import act from './action';
import control from './control';

const rfmData = (obj, form, story, data, d, action) => {
	console.log('[Отчёт - форма] событие', obj);
	switch (obj.type) {
		case 'action':
			return act(obj, form, story, data, d, action);
		case 'control':
			return control(obj, form, story, data, d, action);
		default:
			return status.action;
	}
};

export default rfmData;
